<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :min="fromDate" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: end;">
                <div class="col-md-2" style="margin-top: 29px;" v-if="rows.length">
                    <button class="btn btn-success btn-block" @click="downloadExcelFile" :disabled="!fromDate || !toDate">
                        دریافت خروجی اکسل
                    </button>
                </div>
                <div class="col-md-2" style="margin-top: 29px;">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>شناسه</th>
                        <th>نام</th>
                        <th>نام خانوادگی</th>
                        <th>وضعیت</th>
                        <th>آدرس</th>
                        <th>کد پستی</th>
                        <th>کد پیگیری</th>
                        <th>نوع</th>
                        <th>زمان</th>
                        <th>هزینه ارسال</th>
                        <th>توضیحات</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.orderId }}</td>
                        <td>{{ row.customerFirstName }}</td>
                        <td>{{ row.customerLastName }}</td>
                        <td>{{ row.lastStatus }}</td>
                        <td>{{ row.address }}</td>
                        <td>{{ row.zipCode }}</td>
                        <td>{{ row.trackingCode }}</td>
                        <td>{{ row.deliveryType }}</td>
                        <td>{{ row.deliveryTime }}</td>
                        <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(row.shippingTotalPrice) }}</td>
                        <td>{{ row.description }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"
                                ><i class="icon ion-ios-arrow-forward"></i
                            ></a>
                        </li>
                        <li
                            :class="currentPage == page ? 'page-item active' : 'page-item'"
                            v-for="(page, index) in pages"
                            :key="index"
                        >
                            <div style="display: flex; flex-direction: row;">
                                <span class="page-link ml-1" v-if="page > pages[index - 1] + 1">
                                    ...
                                </span>
                                <a class="page-link" href="#" v-on:click="currentPage = page">{{
                                    page
                                }}</a>
                            </div>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"
                                ><i class="icon ion-ios-arrow-back"></i
                            ></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            fromDate: '',
            toDate: '',
            currentPage: 1,
            pan: '',
            pages: [1],
            perPage: 10,
            today: moment().format('jYYYY-jMM-jDD'),
            lastDeposit: 0,
            showCard: false,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        handlePaginateArray(pagesCount) {
            let pagesArray = [1];
            if (pagesCount > 1) {
                if (this.currentPage > 2) pagesArray.push(this.currentPage - 1);
                if (this.currentPage > 1) pagesArray.push(this.currentPage);
                if (this.currentPage < pagesCount) pagesArray.push(this.currentPage + 1);
                const middle = Math.ceil(pagesCount / 2);
                if (middle > this.currentPage + 1 && middle < pagesCount - 2) {
                    pagesArray.push(middle);
                }
                if (this.currentPage < pagesCount) pagesArray.push(pagesCount);
            }
            this.pages = pagesArray;
        },
        getData(excel = false){
            this.showLoading = true;
            const postedData = {
                fromDate: moment(this.fromDate,'jYYYY-jMM-jDD').format('YYYY-MM-DD'),
                toDate: moment(this.toDate,'jYYYY-jMM-jDD').format('YYYY-MM-DD'),
                page: this.currentPage,
                take:excel ? this.count : this.perPage,
                takeFile: excel
            };
            this.$api.post('Shipping/ShippingReport',postedData).then(({data}) => {
                if(data.status && excel){
                    window.open('https://cardapi.sabinarya.com/download/' + data.result.file)
                    return
                }
                if(data.status){
                    this.rows = data.result.shippingLogList;
                    this.count = data.result.totalCount;
                    let calcPages = Math.ceil(this.count / this.perPage);
                    this.handlePaginateArray(calcPages);
                }else{
                    this.rows = [];
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        downloadExcelFile(){
            this.getData(true);
        },
        submit(){
            this.getData();
        }
    }
}
</script>